export default __webpack_public_path__ + "static/media/GooeyRingSpinner.08f22500.svg";